import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { CustomButton } from '../../components';
import { CatalogItems } from '../../components/Catalog/CatalogItems';
import { useActions } from '../../hooks/useActions';
import { useCatalog } from '../../hooks/useCatalog';
import { useSearch } from '../../hooks/useSearch';

import './Search.sass';

//Страница поиска. Форма
export const SearchPage = () => {
  const { setLimit, setSearchValue, fetchSearchPage, setPage } = useActions();
  const { value, limit, itemsPage, handleSearch, handleEnter } = useSearch();
  const {
    selectSort,
    availabilityOrNo: { availability },
  } = useCatalog();

  const mobileScreen = useMediaQuery('(max-width:900px)');

  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get('q') || '';

  //Получить категории (7 шт)
  const getCategories = () => {
    interface retCatI {
      catStr: 'processes' | 'materials' | 'equipment';
      catObj: any;
    }

    let cat: retCatI[] = [];

    if (itemsPage != null) {
      if (itemsPage.processes?.length > 0)
        for (const it of itemsPage.processes)
          cat.push({
            catStr: 'processes',
            catObj: it,
          });
      if (itemsPage.materials?.length > 0)
        for (const it of itemsPage.materials)
          cat.push({
            catStr: 'materials',
            catObj: it,
          });
      if (itemsPage.equipments?.length > 0)
        for (const it of itemsPage.equipments)
          cat.push({
            catStr: 'equipment',
            catObj: it,
          });
    }

    //Обрезаем до 7
    if (cat.length > 7) cat.length = 7;

    return cat;
  };

  // Показать еще 30
  const handleShowMore = () => {
    const newLimit = limit + 16;
    setLimit(newLimit);
  };

  useEffect(() => {
    fetchSearchPage({
      value: searchQuery != "" ? searchQuery: value,
      limit,
      sort: selectSort,
      availability,
    });
  }, [selectSort, handleSearch, limit, availability, handleEnter, searchQuery]);

  // useEffect(() => {
  //   if (value !== '') {
  //     setSearchParams({ q: value });
  //   }
  // }, [handleSearch]);

  useEffect(() => {
    setPage('searchPage');
    //setSearchValue(value || searchQuery);
  }, []);

  let categories = getCategories();
  let isShow: boolean =
    itemsPage?.catalog_items &&
    itemsPage?.catalog_items?.length > 0 &&
    categories.length > 0
      ? true
      : false;

  return (
    <div
      className={classNames('Search', {
        desktop: !mobileScreen,
        mobile: mobileScreen,
      })}
    >
      <div className="Search__content">
        <h1 className="Search__left_title">
          {(itemsPage?.catalog_items && itemsPage?.catalog_items?.length) ||
          categories.length > 0
            ? `Найдено для «${searchQuery}»`
            : `Не найдено для «${searchQuery}»`}
        </h1>
        <div className="Search__content_wrapper">
          {categories.length > 0 && (
            <div className="Search__left">
              <span className="Search__left_caption">Найдено в категориях</span>
              <div className="Search__left_items">
                {categories.map((item: any) => (
                  <Link
                    to={`/${item.catStr}/${item.catObj.slug}`}
                    className="Search__left_item_link"
                  >
                    <span
                      key={`${item.catObj.slug}-${item.catObj.id}`}
                      className="Search__left_item"
                      dangerouslySetInnerHTML={{ __html: item.catObj.title }}
                    ></span>
                  </Link>
                ))}
              </div>
            </div>
          )}
          <div
            className={classNames('Search__right', {
              search_items:
                (itemsPage && !itemsPage.processes.length) ||
                (itemsPage && !itemsPage.materials.length) ||
                (itemsPage && !itemsPage.equipments.length),
            })}
          >
            {/*{categories.length > 0 && itemsPage?.catalog_items && itemsPage?.catalog_items.length > 0 ? (
              <div className="Search__right_top">
                <Select displayEmpty>
                  <MenuItem>Сначала популярные</MenuItem>
                </Select>
                <div className="catalog-page-center--top">
                  <SwitchActive onActive={onCatalogSwitch} active={catalogSwitchActive} catalog />
                </div>
              </div>
            ) : (
              <></>
            )}*/}

            {itemsPage &&
            itemsPage.catalog_items &&
            itemsPage.catalog_items.length > 0 ? (
              <CatalogItems type="catalog" items={itemsPage.catalog_items} />
            ) : (
              <div style={{ color: '#bebebe' }}>Товар отсутствует...</div>
            )}
            {itemsPage &&
            itemsPage?.catalog_items &&
            itemsPage?.catalog_items?.length >= 15 ? (
              <CustomButton
                onClick={handleShowMore}
                className="button_show-more search_btn"
                variant="outlined"
              >
                Показать больше товаров
              </CustomButton>
            ) : (
              <></>
            )}
          </div>
          {/*<div className="Search__right">
            <div className="Search__right_top">
              <Select displayEmpty>
                <MenuItem>Сначала популярные</MenuItem>
              </Select>
              <SwitchActive
                onActive={onCatalogSwitch}
                active={catalogSwitchActive}
                catalog
              />
            </div>
            <div className="Search__right_wrapper">
              {suggestions &&
                suggestions.catalog?.catalog_items &&
                suggestions.catalog?.catalog_items?.map(
                  (item: any, index: number) => (
                    <Link
                      to={`/items/${encodeURIComponent(item.slug)}`}
                      className="Search__right_item_link"
                    >
                      <div
                        className={`Search__right_item ${
                          index != 0 ? 'Search__right_item--interval' : ''
                        }`}
                        key={item.id}
                      >
                        <div className="Search__right_item_img">
                          <img src={item.img ? item.img : emptyImage} />
                        </div>
                        <div className="Search__right_item_details">
                          <div className="Search__right_item_details_code">
                            <span className="Search__right_item_details_price">
                              <span>
                                {Util.convertKopecksToRub(item.price_kopecks)}
                              </span>{' '}
                              ₽
                            </span>
                          </div>
                          <span
                            className="Search__right_item_details_description"
                            dangerouslySetInnerHTML={{
                              __html: formatSuggestion(
                                clearSuggestion(item.title),
                                item.id
                              ),
                            }}
                          ></span>
                        </div>
                      </div>
                    </Link>
                  )
                )}
            </div>
          </div>*/}
        </div>
      </div>
    </div>
  );
};
